import React from 'react'
import { theme } from '@chakra-ui/core'

export default {
  ...theme,
  fonts: {
    body: 'Roboto, sans-serif',
    heading: 'Roboto, sans-serif',
    mono: 'Roboto, sans-serif',
  },
  fontSizes: {
    xs: '9px',
    sm: '11px',
    md: '12px',
    lg: '14px',
    xl: '16px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '36px',
    '5xl': '48px',
    '6xl': '64px',
    cartTitle: '14px',
    category: '12px',
    categoryTab: '12px',
    productTitle: '12px',
    productDescription: '9px',
  },
  space: {
    ...theme.space,
    px: '1px',
    '1': '0.20rem',
    '2': '0.6rem',
    '3': '0.8rem',
    '5': '1.2rem',
    '6': '1.6rem',
    '10': '2.6rem',
    '12': '3.2rem',
  },
  shadows: {
    ...theme.shadows,
    md: '0px 0px 8px rgba(215, 215, 215, 0.5)',
  },
  colors: {
    ...theme.colors,
    primary: {
      50: '#9FBDF4',
      100: '#9FBDF4',
      200: '#9FBDF4',
      300: '#9FBDF4',
      400: '#9FBDF4',
      500: '#0046CF',
      600: '#0046CF',
      700: '#0046CF',
      800: '#0046CF',
      900: '#0046CF',
    },
    secondary: {
      50: '#FBC813',
      100: '#FBC813',
      200: '#FBC813',
      300: '#FBC813',
      400: '#FBC813',
      500: '#FBC813',
      600: '#FBC813',
      700: '#FBC813',
      800: '#FBC813',
      900: '#FBC813',
    },
    gray: {
      50: '#CCCCCC',
      100: '#979797',
      200: '#F1F1F1',
      300: '#F7F9F9',
      400: '#E8E8E8',
      500: '#F1F1F1',
      600: '#F1F1F1',
      700: '#F1F1F1',
      800: '#F1F1F1',
      900: '#F1F1F1',
    },
    red: {
      50: '#FF6868',
      100: '#FF6868',
      200: '#FF6868',
      300: '#FF6868',
      400: '#FF6868',
      500: '#FF6868',
      600: '#FF6868',
      700: '#FF6868',
      800: '#FF6868',
      900: '#FF6868',
    },
    green: {
      ...theme.colors.green,
      400: '#25D366',
    },
  },
  icons: {
    ...theme.icons,
    search: {
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.17208 0C3.21721 0 0 3.21722 0 7.17208C0 11.1269 3.21721 14.3442 7.17208 14.3442C8.93755 14.3442 10.5507 13.6975 11.8003 12.6368L16.9902 17.8267C17.1057 17.9422 17.2574 18 17.4085 18C17.5596 18 17.7113 17.9421 17.8268 17.8267C18.0577 17.5957 18.0578 17.2213 17.8267 16.9902L12.6367 11.8003C13.6975 10.5507 14.3442 8.93752 14.3442 7.17204C14.3441 3.21722 11.1269 0 7.17208 0ZM1.18306 7.17208C1.18306 3.86987 3.8702 1.18303 7.17208 1.18303C10.474 1.18303 13.1611 3.86984 13.1611 7.17208C13.1611 10.4743 10.474 13.1611 7.17208 13.1611C3.8702 13.1611 1.18306 10.4743 1.18306 7.17208Z"
          fill="currentColor"
        />
      ),
      viewBox: '0 0 18 18',
    },
    settings: {
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.37278 0H0V1.1499H2.52439L5.36684 12.761L4.85493 13.8299C4.56193 14.4575 4.59163 15.1823 4.9456 15.7721C5.15158 16.1091 5.43935 16.3676 5.77426 16.5295C5.54123 16.8872 5.40069 17.3158 5.40069 17.7784C5.40069 19.0065 6.35222 20 7.52832 20C8.70442 20 9.65595 19.0064 9.65595 17.7784C9.65595 17.3884 9.55851 17.0224 9.39381 16.7067H13.7763C13.6076 17.0234 13.5162 17.3895 13.5162 17.7784C13.5162 19.0065 14.4677 20 15.6438 20C16.8199 20 17.7716 19.0065 17.7716 17.7784C17.7716 17.3884 17.6741 17.0224 17.5094 16.7067H18.9454V15.5568H6.56344C6.28234 15.5568 6.03524 15.4144 5.88469 15.1614L5.88414 15.1605C5.73469 14.9162 5.72095 14.6097 5.84559 14.3424L6.29059 13.4059H19.4745L22 2.82716H4.06404L3.37278 0ZM6.37555 12.256L4.35102 3.97707H20.5932L18.611 12.256H6.37555ZM6.50194 17.7785C6.50194 17.187 6.9619 16.7067 7.52837 16.7067C8.09489 16.7067 8.55479 17.1869 8.55479 17.7785C8.55479 18.37 8.09489 18.8502 7.52837 18.8502C6.96184 18.8502 6.50194 18.37 6.50194 17.7785ZM14.6103 17.7785C14.6103 17.187 15.0702 16.7067 15.6367 16.7067C16.2032 16.7067 16.6631 17.1869 16.6631 17.7785C16.6631 18.37 16.2032 18.8502 15.6367 18.8502C15.0702 18.8502 14.6103 18.37 14.6103 17.7785Z"
          fill="currentColor"
        />
      ),
      viewBox: '0 0 22 20',
    },
    plus: {
      path: <path fillRule="evenodd" clipRule="evenodd" d="M9 7V0H7V7H0V9H7V16H9V9H16V7H9Z" fill="currentColor" />,
      viewBox: '0 0 16 16',
    },
    minus: {
      path: <path d="M16 2H0V0H16V2Z" fill="currentColor" />,
      viewBox: '0 0 16 2',
    },
    'chevron-left': {
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.2166 6.5L21.5 7.75478L13.0668 16L21.5 24.2452L20.2166 25.5L10.5 16L20.2166 6.5Z"
          fill="currentColor"
        />
      ),
      viewBox: '0 0 32 32',
    },
  },
}
